// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleInputConfigurationAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import FontSettingsPopup from 'share/components/controls/CommonPopup/Izenda.FontSettingsPopup';
import { withHandlers } from 'recompose';
import { curry } from 'lodash/fp';

/**
 * Save font settings and close fonts popup
 * @param settings
 */
const onSave = (props, settings) => {
  const reportPart = props.reportPart;
  const fn = props.dataKey === 'previewTitle' ? 'updateTitleSettings' : 'updateDescriptionSettings';

  reportPart[fn] && reportPart[fn](settings);
};

/**
 * Toggle font popup
 */
const togglePopup = props => () => {
  const reportPart = props.reportPart;
  const dataKey = props.dataKey;
  const fontSetting = getFontSettings(props);

  props.openPopup(FontSettingsPopup, {
    title: props.title,
    font: fontSetting(),
    save: curry(onSave)(props)
  });
};

const getFontSettings = props => () => {
  const reportPart = props.reportPart;
  const dataKey = props.dataKey;
  const settings = reportPart[dataKey].settings;
  const font = settings.font;
  const alignment = settings.alignment.alignment;

  return {
    fontFamily: font.family,
    fontSize: font.size,
    fontBold: font.bold,
    fontItalic: font.italic,
    fontUnderline: font.underline,
    fontColor: font.color,
    fontHighlightColor: font.highlightColor,
    alignment
  };
};

export default withHandlers({ togglePopup, getFontSettings });



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.SimpleInputConfigurationAction.js